import React, {Fragment} from 'react';
import i18n from 'i18next';
import WebView from '@/Layouts/WebView';
import ValidationErrors from '@/Components/ValidationErrors';
import {Head, Link, useForm, usePage} from '@inertiajs/inertia-react';
import {PhoneOrEmailInput} from "@/Components/Controls";
import ProductLogo from "@/Components/ProductLogo";
import Button from "@/Components/Button";
import styles from "@/../sass/webview/components/ForgotPassword.module.scss"
import AbstractLoginArtwork from "@/Components/AbstractLoginArtwork";

export default function ForgotPassword() {
    const {data, setData, post, processing, errors} = useForm({
        login_method: '',
        from: 'webview',
        send_type: 'token',
        organization: usePage().props.organization.uuid    });

    const organization = usePage().props.organization;
    const status = usePage().props.status;

    const onChange = (name, value) => {
        setData(name, value);
    };

    const submit = (e) => {
        e.preventDefault();

        post(route('webview.password.send-notification', {organization: organization.uuid}));
    };

    return (
        <WebView>
            <Head>
                <title>Forgot Password</title>
            </Head>
            <AbstractLoginArtwork/>
            <div className={"forgot-password"}>
                <form onSubmit={submit}>
                    <ProductLogo />
                    <ValidationErrors errors={errors}/>
                    <Fragment>
                        {status &&
                            <div className={styles.instructions}>
                                <p>{i18n.t("forgot-password.check-email")}</p>
                                <p>{i18n.t("forgot-password.we-sent-email-to")} <b>{data.login_method}</b></p>
                            </div>
                        }
                        {!status &&
                            <Fragment>
                                <div className={styles.instructions}>{i18n.t("forgot-password.enter-email")}</div>
                                <div className="row">
                                    <PhoneOrEmailInput
                                        name="login_method"
                                        isFocused={true}
                                        value={data.login_method}
                                        onChange={onChange}
                                        label={i18n.t("forgot-password.email-or-phone")}
                                        className="col-12"
                                        dataQa="forgot-password-send-reset-request"
                                    />
                                </div>
                            </Fragment>
                        }
                        <Button processing={processing} type="submit" className="w-100 btn btn-primary">
                            {status && i18n.t("forgot-password.resend")}
                            {!status && i18n.t("forgot-password.send-reset-request")}
                        </Button>
                        {status &&
                            <Link href={route('webview.password.request', {organization: organization.uuid})}
                                  className={styles.tryAnotherWay}>
                                {i18n.t("forgot-password.try-another-way")}
                            </Link>
                        }
                    </Fragment>
                </form>
            </div>
        </WebView>
    );
}
